/**
 * Normalise une note sur /10.
 * Si un bareme est défini, l'utilise. Sinon, si la note > 10, suppose /20.
 */
export const normalizeNote = (n) => {
  const val = typeof n === 'number' ? n : (n?.note || 0);
  const bareme = n?.bareme || (val > 10 ? 20 : 10);
  return (val / bareme) * 10;
};

/**
 * Calcule la moyenne normalisée /10 d'un tableau de notes
 */
export const moyenneNormalisee = (notes) => {
  if (!notes || notes.length === 0) return 0;
  const sum = notes.reduce((acc, n) => acc + normalizeNote(n), 0);
  return Math.round((sum / notes.length) * 100) / 100;
};
